<template>
  <div class="text-center px-4 py-6">
    <Button v-on:click.native="showModal = true">{{$t('widget.generate')}}</Button>

    <md-dialog :md-active.sync="showModal">
      <div class="p-4 h-full flex flex-col">
        <p class="px-2 my-2">{{$t('widget.copy_code')}}</p>
        <p class="px-2 text-gray-600 font-semibold text-sm">
          {{$t('widget.size')}}
          <md-field>
            <md-input type="number" v-model="widgetWidth"></md-input>
          </md-field> px
          <md-field>
            <md-input type="number" v-model="widgetHeight"></md-input>
          </md-field> px
        </p>
        <div class="relative flex-1 bg-gray-200 rounded mt-4">
          <pre class="p-2 text-xs font-mono text-gray-700">{{code}}</pre>

          <md-button
            class="md-icon-button md-accent absolute right-0 top-0 hidden sm:inline-block"
            v-clipboard:copy="code"
          >
            <Icon :icon="['far', 'fa-copy', 'text-xl']"/>
          </md-button>
        </div>
      </div>
      

      <md-dialog-actions class="pr-4">
        <md-button class="md-primary" @click="showModal = false">Close</md-button>
        <md-button class="md-raised md-accent sm:hidden" v-clipboard:copy="code">
          <span class="flex items-center">
            <Icon :icon="['far', 'fa-copy', 'text-base']"/>
            <span class="ml-2">{{$t('widget.copy')}}</span>
          </span>
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Button from '@/components/atoms/Button';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'CodeModal',
  components: {
    Button,
    Icon,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  
  data() {
    return {
      widgetWidth: 280,
      widgetHeight: 400,
      showModal: false,
    };
  },

  computed: {
    code() {
      return `<!-- air quality sensor widget  -->
<iframe
  width="${this.widgetWidth}"
  height="${this.widgetHeight}"
  style="border: none"
  src="${window.location.origin}/${this.$route.params.lang}/${this.id}"
></iframe>`;
    }
  },
};
</script>

<style lang="scss">
.md-dialog-container {
  transform: scale(1);

  @media (min-width: theme('screens.sm')) {
    width: 600px;
  }
}
</style>

<style lang="scss" scoped>
.md-icon-button {
  @apply .m-2;
}

.md-button.md-raised {
  box-shadow: none;
}

.md-field {
  @apply .inline-block .w-12 .-mt-4 .mb-0 .ml-3;

  input[type="number"] {
    @apply .text-gray-600 .w-full .px-1 .text-right;

    &::-webkit-inner-spin-button, 
    &::-webkit-outer-spin-button { 
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0; 
    }
  }
}
</style>
